import gql from 'graphql-tag'

const setLocalComments = gql`
  mutation setLocalComments($comments: String) {
    setComments(comments: $comments) @client
  }
`

export default setLocalComments
